import { toast } from "react-toastify";

/**
 * Show user-friendly toast message based on:
 * 1. Server's custom message (if any)
 * 2. HTTP status code
 * 3. Network error
 * 4. Fallback message
 *
 * @param {Object} error - Error object from API
 */
const handleErrorToast = (error) => {
  const status = error?.response?.status;
  const responseMsg = error?.response?.data?.message;
  const errorMsg = error?.message;
  const isNetworkError = errorMsg?.toLowerCase().includes("network");

  const statusMessages = {
    400: "Invalid input. Please check your data.",
    401: "Unauthorized. Please log in.",
    403: "Forbidden. You do not have access.",
    404: "Not found. The requested resource doesn't exist.",
    409: "Conflict. Duplicate or invalid operation.",
    422: "Validation failed. Please fix the errors.",
    500: "Internal server error. Please try again later.",
    503: "Service temporarily unavailable. Try again shortly.",
  };

  const finalMessage =
    responseMsg || 
    statusMessages[status] ||
    (isNetworkError && "Network error. Please check your internet connection.") ||
    errorMsg ||  
    "Something went wrong. Please try again.";

  toast.error(finalMessage);
};

export default handleErrorToast;
